module.exports = ".table-extern{\r\n\tposition: absolute;\r\n\tleft: 15px;\r\n\tright: 0;\r\n\ttop: 110px;/*150px*/\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n}"